import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RenaultPuntoapuntoLocalCampaignOrderDTO } from 'src/app/models/renault-puntoapunto-local-campaign-order';
import { LocalCampaignOrderService } from 'src/app/services/local-campaign-order.service';
import { PuntoapuntoLocalCampaignOrderService } from 'src/app/services/puntoapunto-local-campaign-order.service';



@Component({
  selector: 'puntoapunto-declined-reason-modal',
  templateUrl: './puntoapunto-declined-reason-modal.component.html',
  styleUrls: ['./puntoapunto-declined-reason-modal.component.scss']
})
export class PuntoapuntoDeclinedReasonComponent implements OnInit {

  dataform: FormGroup;
  submitted = 0;
  @Input() idOrder;
  order: RenaultPuntoapuntoLocalCampaignOrderDTO;

  constructor(public activeModal: NgbActiveModal,
    private orderService: PuntoapuntoLocalCampaignOrderService) { }

  ngOnInit(): void {

    this.dataform = new FormGroup({
      reason: new FormControl(null, [Validators.required])
    });

    if (this.idOrder) {
      this.orderService.get(this.idOrder).subscribe(res => {
        this.order = res;
        this.dataform.controls.reason.setValue(this.order.DeclinedReason);
      })
    }


  }

  save() {

    this.submitted = 1;
    if (this.dataform.invalid) return;

    this.activeModal.close(this.dataform.controls.reason.value);


  }

  closeModal() {
    this.activeModal.close(null);
  }


}
